// React
import React from 'react';
import { Input } from 'reactstrap';
import CpfCnpj from '@react-br-forms/cpf-cnpj-mask';

// This component accepts both for formatter: CPF or CNPJ
// CpfCnpjInput
export const InputCpfCnpj = ({ isCPF = false, ...rest }) => {
  return (
    <div>
      <Input
        {...rest}
        type="tel"
        tag={CpfCnpj}
        placeholder={isCPF ? 'Digite um CPF' : 'Digite um CNPJ'}
      />
    </div>
  );
};
